import React from 'react';

import { ErrorMessageParams } from './Types';

import * as styles from './styles.module.css';

const ErrorMessage = (params: ErrorMessageParams): JSX.Element => {
  const { error } = params;

  return <div className={styles.error}>{error}</div>;
};

export default ErrorMessage;
